export default () => {
  /**
   * Initial menu for mobile
   */
  let submenu              = document.querySelector('.sub-menu');
  let mainHeader           = document.querySelector('.mainHeader');
  let subMenuToggle        = document.querySelectorAll('.sub-menu-toggle');
  let menuItemWithChildren = document.querySelectorAll('.menu-item-has-children');
  let menuToggleElem       = document.querySelector('.mainHeader__menuToggleIcon');
  let body                 = document.querySelector('body');
  let menuToggle           = false;
  let menuItemCurrentClass = "current-menu-item";

  let menuIconOpen  = "icon-menu";
  let menuIconClose = "icon-cross";

  let menuLinks = mainHeader.querySelectorAll('.menu a');

  menuLinks.forEach(link => {
    link.addEventListener('click', e => {
      if (mainHeader.classList.contains('menu-open')) {
        closeMenu();
      }
    });
  });

  //toggle next submenu element
  menuItemWithChildren.forEach(item => {
    item.addEventListener('click', e => {
      if (mainHeader.classList.contains('menu-open')) {
        e.currentTarget.classList.toggle('sub-menu-active');
      }
    });
  });

  //toggle menu icon
  menuToggleElem?.addEventListener('click', () => {
    menuToggleElem.classList.toggle(menuIconOpen);
    menuToggleElem.classList.toggle(menuIconClose);
    mainHeader.classList.toggle('menu-open');
    body.classList.toggle('menu-open');
  });

  function closeMenu() {
    menuToggleElem.classList.add(menuIconOpen);
    menuToggleElem.classList.remove(menuIconClose);
    mainHeader.classList.remove('menu-open');
    body.classList.remove('menu-open');
  }
}